import { useEffect, useState } from "react";
import { generateCounterArgument } from "../../utils/generateContent";
import { Campaign, FacebookPost, FetchedAgent, initRequestArgumentParamenters, slidersValue } from "../../utils/interfaces";
import { AnswerCardStyles, CardActionStyles } from "../Feed/FeedStyle";
import { Alert, Avatar, Box, Button, Card, CardActions, CardHeader, Chip, CircularProgress, Dialog, DialogActions, DialogTitle, Divider, IconButton, Slider, Snackbar, TextField, Tooltip, TooltipProps, Typography, styled, tooltipClasses } from "@mui/material";
import { handleMaxRow } from "../../utils/postUtils";
import SliderControls from "../AnswerCard/SliderControls";
import RefreshIcon from '@mui/icons-material/Refresh';
import { sendFacebookComment, sendPrivateMessage } from "./facebookActions";
import { generateResponse } from "./EndpointService/GenerateResponse";
import { mapFacebookPost, mappedFacebookPostToJson } from "./EndpointService/mapCommentSchema";

interface AnswerLog {
    text: string,
    slidersValue: slidersValue
}
interface prop {
    campaignId: string;
    agent: FetchedAgent;
    commentId: string,
    isOpen: boolean,
    author: { name: string, id: string },
    content: string,
    post: FacebookPost
}
const CampaignAnswer = ({ agent, campaignId, commentId, author, isOpen, content, post }: prop) => {
    const [isCommentSending, setIsCommentSending] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false); // State to manage Snackbar visibility
    const [isLoading, setIsLoading] = useState(true);
    const [responseText, setResponseText] = useState("Loading Response...");
    const [sliderValue, setSliderValue] = useState<slidersValue>({
        toneValue: 2,
        lengthValue: 3,
        languageStyleValue: 1,
        communicationToneValue: 2
    })
    const [previousResponses, setPreviousResponses] = useState<AnswerLog[]>([]);

    const handleRegenerate = async () => {
        console.log({
            "comment": commentId,
            "content": content
        })
        setIsLoading(true);
        setResponseText("Loading ...");
        try {
            const result = await generateResponse(
                campaignId,
                agent.agent_id,
                commentId,
                sliderValue,
                content,
                mapFacebookPost(post)
            );
            setResponseText(result);

            setPreviousResponses([...previousResponses,
            {
                text: result, slidersValue:
                {
                    toneValue: sliderValue.toneValue,
                    lengthValue: sliderValue.lengthValue,
                    languageStyleValue: sliderValue.languageStyleValue,
                    communicationToneValue: sliderValue.communicationToneValue
                }
            }])
        } catch (error: any) {
            setResponseText(error as string);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            handleRegenerate();
        }
    }, [isOpen, commentId])

    const handleSnackbarClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const classes = AnswerCardStyles;
    const styles = CardActionStyles;

    const handleComment = () => {

        setIsCommentSending(true); // Start sending process
        sendFacebookComment(responseText, commentId, () => {
            setIsCommentSending(false);
            setSnackbarOpen(true); // Open Snackbar on successful comment
        });
    }
    const handlePrivateMessage = () => {
        console.log('sending comment... ')
        sendPrivateMessage(responseText, author.id)
    }

    return (
        <Box>
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 2,
                    boxShadow: 3,
                    width: '70%',
                    marginLeft: '15%'
                }}>
                <Box>
                    <Box sx={{
                        display: 'flex', width: '100%', flexDirection: "column",
                        alignItems: "flex-start", justifyContent: 'space-between'
                    }}>



                        <Box sx={{ width: '95%', padding: '10px 10px 0 10px', position: 'relative' }}>
                            <TextField
                                sx={{
                                    width: '100%',
                                    ...(isLoading && {
                                        animation: 'blink 3s linear infinite',
                                        '@keyframes blink': {
                                            '0%': { opacity: 1 },
                                            '50%': { opacity: 0 },
                                            '100%': { opacity: 1 },
                                        },
                                    })
                                }}
                                inputProps={{ style: { fontSize: 14 } }}
                                label="Suggested Comment"
                                multiline
                                maxRows={5}
                                minRows={5}

                                value={isLoading ? "Loading Response..." : responseText}
                                onChange={(e: any) => setResponseText(e.target.value)}
                            />
                            <SliderControls isLoading={isLoading} sliderValue={sliderValue} setSliderValue={setSliderValue} />
                        </Box >
                    </Box>
                </Box>
                <CardActions sx={styles.AnswerCardActions}>

                    <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
                        <Button
                            size="small"
                            sx={{ height: '70%', marginLeft: '20px', fontSize: "12px" }} onClick={() => handleRegenerate()}
                            startIcon={
                                <RefreshIcon />}>
                            Generate Response
                        </Button>
                        <Button
                            variant="contained"

                            size="small"
                            sx={{ height: '70%', marginLeft: '20px', fontSize: "12px" }} onClick={() => handlePrivateMessage()}
                        >
                            Message User
                        </Button>
                        <Button
                            variant="contained"

                            size="small"
                            sx={{ height: '50px', marginLeft: '20px', fontSize: "12px" }} onClick={() => handleComment()}
                        >
                            {isCommentSending ? <CircularProgress color="secondary" size={24} /> : "Reply To Comment"}
                        </Button>
                    </Box>
                </CardActions>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => handleSnackbarClose}>
                    <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                        Comment sent successfully!
                    </Alert>
                </Snackbar>
            </Box >
        </Box>
    );
}
export default CampaignAnswer